// extracted by mini-css-extract-plugin
export default {"form":"form__vZGdr7h0foWRlWZTH9RA","title":"title__p4NdWUuAXoXoDp4TQ3Nk"};